/**
 * Notifications API 서비스
 * apiRequest 통합 버전
 */

import apiRequest from './api';

const NOTIFICATIONS_API = '/api/notifications';

/**
 * 알림 목록 조회
 */
export const fetchNotifications = async (unreadOnly = false, limit = 50) => {
  const params = new URLSearchParams();
  if (unreadOnly) params.append('unreadOnly', 'true');
  if (limit) params.append('limit', limit);
  return apiRequest(`${NOTIFICATIONS_API}?${params}`);
};

/**
 * 알림 읽음 처리
 */
export const markNotificationAsRead = async (notificationId) => {
  return apiRequest(`${NOTIFICATIONS_API}/${notificationId}/read`, {
    method: 'PUT'
  });
};

/**
 * 모든 알림 읽음 처리
 */
export const markAllNotificationsAsRead = async () => {
  return apiRequest(`${NOTIFICATIONS_API}/read-all`, {
    method: 'PUT'
  });
};

/**
 * 알림 삭제
 */
export const deleteNotification = async (notificationId) => {
  return apiRequest(`${NOTIFICATIONS_API}/${notificationId}`, {
    method: 'DELETE'
  });
};

/**
 * 모든 알림 삭제
 */
export const deleteAllNotifications = async () => {
  return apiRequest(NOTIFICATIONS_API, {
    method: 'DELETE'
  });
};

/**
 * 알림 생성 (Admin)
 */
export const createNotification = async (notificationData) => {
  return apiRequest(NOTIFICATIONS_API, {
    method: 'POST',
    body: JSON.stringify(notificationData)
  });
};
